export const baseUrlForApi = "https://api.playgroundsessions.com";
export const baseUrlForWebsite = "https://www.playgroundsessions.com";